import {
  Col,
  Divider,
  Form,
  message,
  Modal,
  Row,
  Skeleton,
  Space,
  Typography,
} from "antd";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import logoNotif from "../../assets/icon/notif-logo.svg";
import ellipseRed from "../../assets/icon/ellipse-2.svg";
import {
  generateErrorMessage,
  sendPatchRequest,
} from "../../services/request-adapter";
import { setLoading } from "../../stores/auth/actions";
import { fetchAllNotifications } from "../../stores/masterData/actions";
import { useNavigate } from "react-router-dom";

const NotificationList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { notifications, loading, totalUnread } = useSelector(
    (state) => state.masterData
  );

  const markAsRead = async (notif) => {
    const { id: idNotif, message } = notif;
    const urlRedirect = message?.data?.url;
    dispatch(setLoading(true));
    navigate(urlRedirect);
    try {
      await sendPatchRequest(`/notifications/${idNotif}`, { read_at: true });
      await dispatch(fetchAllNotifications());
    } catch (error) {
      message(generateErrorMessage(error));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <div>
      {loading ? (
        <Skeleton active />
      ) : (
        <div
          style={{
            paddingTop: "24px",
            background: "#ffffff",
            boxShadow: "0px 40px 100px rgba(68, 68, 79, 0.1)",
            borderRadius: "10px",
            width: "50vw",
          }}
          gutter={[0, 16]}
        >
          <Typography.Title level={5} style={{ paddingLeft: "24px" }}>
            Notification{" "}
            {totalUnread > 0 && (
              <span
                style={{
                  background: "#E23A0F",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  borderRadius: "100px",
                  color: "white",
                }}
              >
                {totalUnread}
              </span>
            )}
          </Typography.Title>
          <Divider
            style={{
              marginBottom: 0,
            }}
          />
          <div
            style={{
              paddingBottom: "24px",
              overflowY: "scroll",
              maxHeight: "60vh",
              position: "relative",
            }}
          >
            {notifications.data.map((notif) => {
              return (
                <div
                  style={{
                    padding: "10px",
                    cursor: "pointer",
                  }}
                  className="hover-notif"
                  onClick={() => markAsRead(notif)}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#F5FBFF",
                          padding: "13px",
                          borderRadius: "100%",
                        }}
                      >
                        <img height={"20px"} src={logoNotif} alt="notif-logo" />
                      </div>

                      <div
                        style={{
                          marginLeft: "10px",
                        }}
                      >
                        <p
                          style={{
                            fontWeight: "600",
                            fontSize: "12px",
                            lineHeight: "150%",
                            color: "#212529",
                            margin: 0,
                          }}
                        >
                          {notif.message.title}
                        </p>
                        <p
                          style={{
                            fontWeight: "400",
                            color: "#737373",
                            margin: 0,
                            width: "50wv",
                          }}
                        >
                          {notif.message.body}
                        </p>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "-20px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <span
                        style={{
                          color: "#B9B9B9",
                          fontSize: "10px",
                          marginRight: "20px",
                        }}
                      >
                        {notif.created_at}
                      </span>
                      {!notif.read_at && <img src={ellipseRed} alt="dot-red" />}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationList;
